import React, { useEffect, useState } from 'react';
import BrandLogo from './BrandLogo';
import {
  VehicleUtilityInfo,
  SavedBuildsCounter,
} from '../utilityBar/UtilityBar';
import { connect } from 'react-redux';
import _ from 'lodash';
import useLargeBreakpoint from '../../hooks/useLargeBreakpoint';

const GlobalNav = ({
  setNavRendered,
  modelInfo,
  config,
  isSelectionRevealed,
  isBodyTypeRevealed,
  savedBuildCount,
}) => {
  const { quantumData, enableFallbackNavigation } = modelInfo;
  const { globalNavMarkup } = quantumData;
  const isAtLeastLarge = useLargeBreakpoint();
  const [isHeartActive, setIsHeartActive] = useState(false);

  const bodyTypeDescription = _.get(config, 'bodyType.formattedConfig', '');
  const trimName = _.get(config, 'style.trimName', '');
  const driveType = _.get(config, 'driveType.id', '');
  const { year, title } = modelInfo;
  const isRevealed =
    (trimName || bodyTypeDescription) &&
    (isBodyTypeRevealed || isSelectionRevealed);

  useEffect(() => {
    if (enableFallbackNavigation) {
      setNavRendered(true);
      return;
    }

    document.body.insertAdjacentHTML('afterbegin', globalNavMarkup);
  }, []);

  useEffect(() => {
    setIsHeartActive(savedBuildCount > 0);
  }, [savedBuildCount]);

  return (
    <>
      {enableFallbackNavigation ? (
        <nav className="fallback-global-nav">
          <BrandLogo modelInfo={modelInfo} showBackArrow />
          {isAtLeastLarge ? (
            <>
              <VehicleUtilityInfo
                config={bodyTypeDescription}
                trim={trimName}
                driveType={driveType}
                bodyStyle={title}
                year={year}
                isRevealed={isRevealed}
                isSelectionRevealed={isSelectionRevealed}
                modifier="global-nav"
              />
              <div className="fallback-global-nav__saved-builds-counter-container">
                <SavedBuildsCounter
                  isHeartActive={isHeartActive}
                  savedBuildCount={savedBuildCount}
                  modifier="global-nav"
                />
              </div>
            </>
          ) : null}
        </nav>
      ) : null}
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  const {
    config,
    isSelectionRevealed,
    isBodyTypeRevealed,
    savedBuildCount,
  } = state;

  return {
    config,
    isSelectionRevealed,
    isBodyTypeRevealed,
    savedBuildCount,
    ...ownProps,
  };
};

export default connect(mapStateToProps)(GlobalNav);
